import { Tab } from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { DiplomeDetailPage } from "../../..";
import { DiplomeApi } from "../../../../../api";
import { ERoutes } from "../../../../../AppRouter";
import { BackButton, PageBase, ProtectedTabs } from "../../../../../components";
import { useApiService, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";

interface IDiplomeItemPageProps {}

export const DiplomeItemPage: React.FunctionComponent<IDiplomeItemPageProps> = () => {
  const { t } = useTl();
  const { id, tab, state = "edit" } = useParams<{ id: string; tab: string; state: string }>();
  const idDiplome = React.useMemo(() => +id, [id]);
  const history = useHistory();

  const diplomeApi = useApiService(DiplomeApi);
  const [displayName] = useApiEffect(() => diplomeApi.diplomeGetDisplayName({ id: idDiplome }), [id]);

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.Diplomes), route: ERoutes.diplome },
        { text: +id <= 0 ? t(ETLCodes.New) : displayName }
      ]}
    >
      <ProtectedTabs
        id="TabsDiplome"
        onChange={newTabId => history.push(`${ERoutes.diplome}/${id}/${newTabId}/${state}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.diplome}></BackButton>
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<DiplomeDetailPage idDiplome={idDiplome} editMode={state === "edit"} />}
        />
      </ProtectedTabs>
    </PageBase>
  );
};
